import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import TableWithFrontPaginationDesign from "@/components/base/table/TableWithFrontPaginationDesign.vue";
import ContestOfferGoalBonusInput from "@/components_v3/affiliate/contest/entities/cashback-offer/ui/contest-offer-goal-bonus-input/ContestOfferGoalBonusInput.vue";
import { IContestCashbackGoal } from "@/components_v3/affiliate/contest/entities/cashback-offer/model/types";
import { parseOfferMoneyAmount } from "@/components_v3/affiliate/contest/shared/lib/parse-offer-money.lib";
import { PAGINATION_RIGHT_PER_PAGE } from "@/configs/global";
import { ITableHeader } from "@/utils";

interface Props {
    goals: IContestCashbackGoal[];
    offerId?: number | null;
    isEditing?: boolean;
    isLoading?: boolean;
    isNew?: boolean;
    showPeriodBonusColumn?: boolean;
}

interface IContestGoalsTableRoute {
    routeParam: string;
    slot: string;
    routerName: string;
    text: string;
    getQuery: () => Record<string, string>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ContestOfferGoalsTable',
  props: {
    goals: null,
    offerId: { default: null },
    isEditing: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    isNew: { type: Boolean, default: false },
    showPeriodBonusColumn: { type: Boolean, default: false }
  },
  emits: ["update:goals"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update:goals', goals: IContestCashbackGoal[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { goals: IContestCashbackGoal[], offerId: number | null, isEditing: boolean, isLoading: boolean, isNew: boolean, showPeriodBonusColumn: boolean }





const baseHeaders: ITableHeader[] = [
    { text: 'ID Цели', value: 'legacy_id', sortable: false },
    { text: 'Цель', value: 'name', sortable: false, class: 'contest-offer-goals-table__goal-name-col' },
    {
        text: 'Бонус за лид',
        value: 'bonus',
        sortable: false,
        align: 'left',
        class: 'contest-offer-goals-table__bonus-col',
        cellClass: 'contest-offer-goals-table__bonus-col',
    },
];

const headers = computed<ITableHeader[]>(() => {
    if (!props.showPeriodBonusColumn) {
        return baseHeaders;
    }

    return [
        ...baseHeaders,
        {
            text: 'Спец-период бонуса за лид',
            value: 'periodBonus',
            sortable: false,
            align: 'left',
            class: 'contest-offer-goals-table__period-bonus-col',
            cellClass: 'contest-offer-goals-table__period-bonus-col',
        },
    ];
});

const isVisible = computed(() => {
    if (props.isNew && !props.offerId) {
        return false;
    }

    return true;
});

const tableRoutes = computed<IContestGoalsTableRoute[]>(() => {
    if (!props.offerId) {
        return [];
    }

    const offerId = props.offerId;

    return [
        {
            routeParam: 'id',
            slot: 'item.legacy_id',
            routerName: 'offer-goal',
            text: 'legacy_id',
            getQuery: () => ({ offer_id: String(offerId) }),
        },
        {
            routeParam: 'id',
            slot: 'item.name',
            routerName: 'offer-goal',
            text: 'name',
            getQuery: () => ({ offer_id: String(offerId) }),
        },
    ];
});

const tableUniqueData = computed(() => {
    const items = [
        {
            slot: 'item.bonus',
            ...(props.isEditing
                ? {}
                : { template: (item: IContestCashbackGoal) => formatBonus(item.bonus) }),
        },
    ];

    if (props.showPeriodBonusColumn) {
        items.push({
            slot: 'item.periodBonus',
            ...(props.isEditing
                ? {}
                : { template: (item: IContestCashbackGoal) => formatPeriodBonus(item.periodBonus) }),
        });
    }

    return items;
});

function updateBonus(goal: IContestCashbackGoal, bonus: number | null): void {
    // clear / пусто → null (цель не в bonuses → дефолт бэка); явный 0 остаётся 0
    const nextBonus = parseOfferMoneyAmount(bonus);
    const nextGoals = props.goals.map((item) => (
        item.legacy_id === goal.legacy_id ? { ...item, bonus: nextBonus } : item
    ));

    emit('update:goals', nextGoals);
}

function updatePeriodBonus(goal: IContestCashbackGoal, periodBonus: number | null): void {
    const nextPeriodBonus = parseOfferMoneyAmount(periodBonus);
    const nextGoals = props.goals.map((item) => (
        item.legacy_id === goal.legacy_id ? { ...item, periodBonus: nextPeriodBonus } : item
    ));

    emit('update:goals', nextGoals);
}

function formatBonus(bonus: number | null): string {
    if (bonus == null) {
        return '';
    }

    return bonus.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

function formatPeriodBonus(periodBonus: number | null): string {
    if (periodBonus == null) {
        return '';
    }

    return formatBonus(periodBonus);
}

return { __sfc: true,props, emit, baseHeaders, headers, isVisible, tableRoutes, tableUniqueData, updateBonus, updatePeriodBonus, formatBonus, formatPeriodBonus, TableWithFrontPaginationDesign, ContestOfferGoalBonusInput, PAGINATION_RIGHT_PER_PAGE }
}

})